import { IAirCurrency } from "./IAirCurrency";

export interface IAirPrice {
    code?: {
        [host: string]: string;
    };
    currency: IAirCurrency;
    details: any;
    fareType: string;
    farebasis?: any;
    key?: {
        [host: string]: string;
    };
    luggage: ILuggage;
    state: string;
    status?: {
        [host: string]: string;
    };
    total: number;
    totals: any[];
    validity: {
        end: string;
    };
    vendor: string;
    xID: string;
}

export interface ILuggage {
    rule: ILuggageRule[];
}

export interface ILuggageRule {
    segment: string | string[];
    traveller: string | string[];
    in: LuggageType;
    restriction: ILuggageRestriction[];
}

export interface ILuggageRestriction {
    max: number;
    unit: RestrictionUnit;
    topic?: string;
}

export enum LuggageType {
    hold = 'hold',
    cabin = 'cabin'
}

export enum RestrictionUnit {
    luggage = 'luggage',
    centimeter = 'centimeter',
    inch = 'inch',
    kilogram = 'kilogram',
    pound = 'pound',
}